<template>
    <div class="energy-data-query-manage-box">
        <div class="recharge-detail-query-head">
            <div class="recharge-detail-query-head-left">
                <el-row>
                    <el-col>用户列表</el-col>
                </el-row>
            </div>
            <div class="recharge-detail-query-head-right">
                <el-row>
                    <el-col style="height: 2rem;padding-left: 1rem">表单


                        <el-date-picker
                                type="daterange"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                size="small"
                                style="width: 16vw;float: right;"
                                v-model="dateInterval"
                                @change="changeTime"
                                time-arrow-control
                                align="left"

                                :disabled="disabled"
                        >
                            <!--:picker-options="pickerOptions"-->
                        </el-date-picker>
                        <!--<el-radio-group v-model="timePeriod" size="mini"
                                        style="float: right;margin-right: 10px;"
                                        :disabled="disabled">-->
                        <el-radio-group v-model="timePeriod" size="mini"
                                        style="float: right;margin-right: 1rem"
                                        :disabled="disabled">
                            <el-radio-button label="day">日</el-radio-button>
                            <el-radio-button label="week">周</el-radio-button>
                            <el-radio-button label="month">月</el-radio-button>
                            <el-radio-button label="year">年</el-radio-button>
                        </el-radio-group>


                        <!--<el-button size="mini" type="primary" @click="echarts('day')">查询</el-button>-->

                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="recharge-detail-query-content">
            <div class="energy-data-query-left">

                <center>
                    <div class="left-item">
                        <el-form>
                            <!--<el-row style="height: 30px">-->
                            <el-row style="height: 2rem">
                                <el-col>
                                    <el-input v-model="filterText" size="small" :disabled="disabled" style="width: 85%">
                                        <template slot="prepend" style="padding: 0">用户名称/编号</template>
                                    </el-input>
                                    <!--<el-form-item label="用户名称/编号" :label-width="formLabelWidth">
                                        <el-input
                                                v-model="condition.customerId"
                                                class="row" size="mini">
                                        </el-input>
                                    </el-form-item>-->
                                </el-col>
                            </el-row>
                            <!--<el-row>
                                <el-col>
                                    <el-button size="mini" @click="">搜 索</el-button>
                                </el-col>
                            </el-row>-->
                            <!--<el-row style="margin-top: 5px;height: 30px">-->
                            <el-row style="margin-top: 1rem;height: 2rem;">
                                <el-col>
                                    <el-radio-group v-model="meterType" size="mini" :disabled="disabled">
                                        <el-radio-button label="2">电表</el-radio-button>
                                        <el-radio-button label="1">水表</el-radio-button>

                                    </el-radio-group>
                                </el-col>
                            </el-row>

                        </el-form>

                    </div>
                    <div class="div-hr"></div>

                    <div class="tree">
                        <el-container>
                            <!--<el-main ref="elMain" style="height: calc(100vh - 220px)">-->
                            <el-main ref="elMain" style="height: calc(100vh - 20rem)">
                                <el-tree
                                        class="filter-tree"
                                        :data="tree"
                                        :props="defaultProps"
                                        :filter-node-method="filterNode"
                                        node-key="id"
                                        :default-expanded-keys="expandedKeys"
                                        v-loading="loading"
                                        @node-click="click"
                                        highlight-current
                                        :expand-on-click-node="false"
                                        ref="tree"
                                        :indent="fontSize"
                                        style="background-color: #fafafa"
                                >
                                </el-tree>
                                <el-button v-show="tree.length === 0 && !loading" @click="selectEnergyUnit">刷新
                                </el-button>

                            </el-main>
                        </el-container>


                    </div>

                    <!--<div class="log-condition-box">




                    </div>-->


                </center>
            </div>

            <div class="energy-data-query-right">
                <!--<el-radio-group v-model="time" style="margin-left: 15px;">
                    <el-row>
                        <el-radio-button label="day">日</el-radio-button>
                    </el-row>
                    <el-row>
                        <el-radio-button label="week">周</el-radio-button>
                    </el-row>
                    <el-row>
                        <el-radio-button label="month">月</el-radio-button>
                    </el-row>
                    <el-row>
                        <el-radio-button label="year">年</el-radio-button>
                    </el-row>

                </el-radio-group>-->

                <div class="content">
                    <!-- <div>
                         <el-col style="height: 2rem;">


                             <el-date-picker
                                     type="daterange"
                                     unlink-panels
                                     range-separator="至"
                                     start-placeholder="开始日期"
                                     end-placeholder="结束日期"
                                     size="small"
                                     style="width: 16vw;float: right;"
                                     v-model="dateInterval"
                                     @change="changeTime"
                                     time-arrow-control
                                     align="left"

                                     :disabled="disabled"
                             >
                                 &lt;!&ndash;:picker-options="pickerOptions"&ndash;&gt;
                             </el-date-picker>
                             &lt;!&ndash;<el-radio-group v-model="timePeriod" size="mini"
                                             style="float: right;margin-right: 10px;"
                                             :disabled="disabled">&ndash;&gt;
                             <el-radio-group v-model="timePeriod" size="mini"
                                             style="float: right;margin-right: 3rem;"
                                             :disabled="disabled">
                                 <el-radio-button label="day">日</el-radio-button>
                                 <el-radio-button label="week">周</el-radio-button>
                                 <el-radio-button label="month">月</el-radio-button>
                                 <el-radio-button label="year">年</el-radio-button>
                             </el-radio-group>


                             &lt;!&ndash;<el-button size="mini" type="primary" @click="echarts('day')">查询</el-button>&ndash;&gt;

                         </el-col>
                     </div>-->
                    <flex>
                        <el-table
                                @filter-change="handleFilterChange"
                                :data="tableData"
                                size="small"
                                stripe
                                width="100%"
                                height="100%"
                                v-loading="tableLoading"
                        >
                            <!--height="calc(100vh - 210px)" width="100%"-->
                            <!-- <el-table-column
                                     label="序号">
                                 <template scope="scope"><span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span></template>
                             </el-table-column>-->
                            <el-table-column type="expand" width="20">
                                <template slot-scope="props">
                                    <el-form label-position="left" inline class="demo-table-expand">
                                        <el-form-item label="订单号:" :formatter="tableStringFormat">
                                            <span>{{ tableHiddenStringFormat(props.row.id) }}</span>
                                        </el-form-item>
                                        <el-form-item label="用户编号:" :formatter="tableStringFormat">
                                            <span>{{ tableHiddenStringFormat(props.row.customer_user_code) }}</span>
                                        </el-form-item>
                                        <el-form-item label="用户地址:" :formatter="tableStringFormat">
                                            <span>{{ tableHiddenStringFormat(props.row.address) }}</span>
                                        </el-form-item>
                                        <el-form-item label="表号:" :formatter="tableStringFormat">
                                            <span>{{ tableHiddenStringFormat(props.row.meter_num) }}</span>
                                        </el-form-item>
                                        <el-form-item label="仪表编号:" :formatter="tableStringFormat">
                                            <span>{{ tableHiddenStringFormat(props.row.meter_code) }}</span>
                                        </el-form-item>
                                        <el-form-item label="备注:">
                                            <span>{{ tableHiddenStringFormat(props.row.remark) }}</span>
                                        </el-form-item>
                                    </el-form>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="序号"
                                    align="center"
                                    width="45">
                                <template slot-scope="scope">
                                    <span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="recharge_time"
                                    label="充值时间"
                                    :formatter="tableTimeFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="customer_user_name"
                                    label="用户名称"
                                    align="center"
                                    :formatter="tableStringFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="meter_name"
                                    label="仪表名称"
                                    align="center"
                                    :formatter="tableStringFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="channel_name"
                                    label="充值渠道"
                                    align="center"
                                    column-key="channel"
                                    :filters="channelFilter"
                                    :formatter="tableStringFormat
">
                            </el-table-column>
                            <el-table-column
                                    prop="type_name"
                                    align="center"
                                    label="付款方式"
                                    column-key="type"
                                    :filters="typeFilter"
                                    :formatter="tableStringFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="pre_balance"
                                    label="表内余额(元)"
                                    align="center"
                                    :formatter="tableNumberFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="recharge_amount"
                                    label="充值金额(元)"
                                    align="center"
                                    :formatter="tableNumberFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="pay_amount"
                                    label="应付金额(元)"
                                    align="center"
                                    :formatter="tableNumberFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="balance"
                                    label="充值后表内余额(元)"
                                    align="center"
                                    :formatter="tableNumberFormat">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="status"
                                    column-key="rechargeState"
                                    :filters="rechargeState"
                                    label="充值状态"
                                    :formatter="statusFormat"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="operate_name"
                                    label="操作人"
                                    align="center"
                                    :formatter="tableStringFormat">
                            </el-table-column>
                            <el-table-column
                                    label="操作"
                                    align="center"
                                    width="65">
                                <template slot-scope="scope">
                                    <!-- <i class="el-icon-error" v-if="scope.row.status === 0"></i>
                                     <i class="el-icon-success" v-if="scope.row.status === 1"></i>-->
                                    <el-button v-if="scope.row.status === 2" size="mini" type="text"
                                               @click="rowClick(scope.row)">打印凭条
                                    </el-button>
                                    <el-button v-if="scope.row.status === 4" size="mini" type="text"
                                               @click="rechargeClick(scope.row)">重新充值
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </flex>
                    <!--<div style="width: 100%;height:30px;">-->
                    <div class="energy-config-pagination">

                        <el-pagination
                                size="small"
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 30, 50, 100]"
                                :page-size="pageSize"
                                align="center"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="pageTotal"
                                style="padding-top: 1rem;width:100%;"
                                :disabled="disabled">
                        </el-pagination>

                        <el-button @click="excel" size="small" :disabled="disabled">数据导出</el-button>


                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
  import {getStartAndEnd, formatDate, format} from '@/utils/time'
  import {tree, expandedCustomerWithMeter, filterNode} from '@/utils/energyUtilTree'
  import {exportExcel} from '@/utils/excelUtil'
  import {
    rechargeRecordByPage,
    selectRechargeType,
    selectRechargeChannel,
    againRecharge
  } from '@/api/rechargeRecord'
  import {uuidWithoutLine} from "@/utils/uuid"
  import Flex from "../../../components/Flex"
  import {mapGetters} from 'vuex'

  export default {
    name: 'meterManage',
    components: {
      'flex': Flex
    },
    computed: {
      ...mapGetters([
        'screenWidth',
        'fontSize'
      ])
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val)
      },
      meterType(val) { //监听能源类型变化
        this.filterText = ""
        this.selectEnergyUnit()
      },
      timePeriod(val) {  //监听时间区间变化
        if (val !== null) {
          //时间框置空
          this.dateInterval = null
          if (this.meterIds.length != 0) {
            this.currentPage = 1
            this.tableByPage()
          }
        }
      },
      dateInterval(val) {    //监听时间框变化
        if (val !== null) {
          //时间区间置空
          this.timePeriod = null
          if (this.meterIds.length != 0) {
            this.currentPage = 1
            this.tableByPage()
          }
        }
      },
      meterIds(val) {    //监听仪表id变化，查询数据
        this.currentPage = 1
        this.tableByPage()
      }
    },
    mounted() {
      this.selectEnergyUnit()
      /*
            this.timePeriodChange(this.timePeriod)*/
      this.selectRechargeBasicInfo()
      // this.elMainStyle.height = parseInt(this.$refs.elMain.$el.clientHeight * 2.5) + 'px'
      /* this.elContent.height = parseInt(this.$refs.content.$el.clientHeight * 1) + 'px'*/

      /* this.myChart.resize();*/
    },
    methods: {
      rechargeClick(result) { // 重新充值
        this.$confirm('重新充值此仪表？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let commandId = uuidWithoutLine()
          if (result != undefined && result != null) {
            // 重新充值
            againRecharge(result.id, commandId, this.$store.getters.userId).then(response => {
              if (response.code == 200) {
                //记录操作id
                if ("窗口退费" === result.channel_name) {
                  this.$store.getters.refundUUID[commandId] = commandId
                  this.$message({
                    message: '充抵中，请稍候'
                  })
                } else {
                  this.$store.getters.rechargeUUID[commandId] = commandId
                  this.$message({
                    message: '充值中，请稍候'
                  })
                }
              } else {
                this.$message({
                  type: 'error',
                  message: response.message
                })
              }
            }).catch(error => {
              this.$message({
                type: 'error',
                message: '重新充值失败'
              })
            })
          } else {
            this.$message({
              type: 'error',
              message: '重新充值失败'
            })
          }
        }).catch(() => {})
      },
      rowClick(result) {
        let rechargeTime = "--"
        let userName = "--"
        let userCode = "--"
        let address = "--"
        let meterName = "--"
        let meterCode = "--"
        let meterNum = "--"
        let rechargeAmount = "--"
        let rechargeChannel = "--"
        let rechargeType = "--"
        let balance = "--"
        let preBalance = "--"
        let status = "--"
        let operateName = "--"
        let tradeNo = result.id
        if (result.recharge_time !== null && result.recharge_time !== undefined && result.recharge_time !== "") {
          rechargeTime = this.timeFormat(result.recharge_time)
        }
        if (result.customer_user_name !== null && result.customer_user_name !== undefined && result.customer_user_name !== "") {
          userName = result.customer_user_name
        }
        if (result.customer_user_code !== null && result.customer_user_code !== undefined && result.customer_user_code !== "") {
          userCode = result.customer_user_code
        }
        if (result.address !== null && result.address !== undefined && result.address !== "") {
          address = result.address
        }
        if (result.meter_name !== null && result.meter_name !== undefined && result.meter_name !== "") {
          meterName = result.meter_name
        }
        if (result.meter_code !== null && result.meter_code !== undefined && result.meter_code !== "") {
          meterCode = result.meter_code
        }
        if (result.meter_num !== null && result.meter_num !== undefined && result.meter_num !== "") {
          meterNum = result.meter_num
        }
        if (result.recharge_amount !== null && result.recharge_amount !== undefined && result.recharge_amount !== "") {
          rechargeAmount = result.recharge_amount.toFixed(2)
        }
        if (result.channel_name !== null && result.channel_name !== undefined && result.channel_name !== "") {
          rechargeChannel = result.channel_name
        }
        if (result.type_name !== null && result.type_name !== undefined && result.type_name !== "") {
          rechargeType = result.type_name
        }
        if (result.balance !== null && result.balance !== undefined && result.balance !== "") {
          balance = result.balance.toFixed(2)
        }
        if (result.pre_balance !== null && result.pre_balance !== undefined && result.pre_balance !== "") {
          preBalance = result.pre_balance.toFixed(2)
        }
        if (result.status !== null && result.status !== undefined && result.status !== "") {
          if (result.status == 0) {
            status = "支付中"
          } else if (result.status == 1 || result.status == 5) {
            status = "充值中"
          } else if (result.status == 2) {
            status = "充值成功"
          } else if (result.status == 3) {
            status = "支付失败"
          } else if (result.status == 4) {
            status = "充值失败"
          }
        }
        if (result.operate_name !== null && result.operate_name !== undefined && result.operate_name !== "") {
          operateName = result.operate_name
        }
        let content = `<style type='text/css'>
                            .subtitle {text-align: center;font-size: 13px;font-weight: 600;margin-bottom: 2px;}
                            .title {text-align: center;font-size: 13px;margin-bottom: 10px;height: 23px;border-bottom: 1px dashed #999999;}
                            .content-bottom {border-top: 1px dashed #999999;margin-top:2px;}
                            .content-bottom-font{font-size: 9px;color: #464646;text-align: center;margin-top :7px;}
                            .name {width: 48%;float: left;text-align: right;padding-right: 2%;color: #464646;font-size: 10px;line-height: 15px;}
                            .value {width: 50%;float: left;font-size: 11px;line-height: 15px;white-space: normal;word-break: break-all;word-wrap: break-word;}
                         </style>
                         <div class='print'>
                            <div class='subtitle'>AcuBill网络预付费系统</div>
                            <div class='title'>充值记录单</div>
                            <div><div class='name'>充值单号:</div><div class='value'>` + tradeNo + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值时间:</div><div class='value'>` + rechargeTime + `</div><br style='clear:both;'></div>
                            <div><div class='name'>用户名称:</div><div class='value'>` + userName + `</div><br style='clear:both;'></div>
                            <div><div class='name'>用户编号:</div><div class='value'>` + userCode + `</div><br style='clear:both;'></div>
                            <div><div class='name'>用户地址:</div><div class='value'>` + address + `</div><br style='clear:both;'></div>
                            <div><div class='name'>仪表名称:</div><div class='value'>` + meterName + `</div><br style='clear:both;'></div>
                            <div><div class='name'>仪表编号:</div><div class='value'>` + meterCode + `</div><br style='clear:both;'></div>
                            <div><div class='name'>表号:</div><div class='value'>` + meterNum + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值金额(元):</div><div class='value'>` + rechargeAmount + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值渠道:</div><div class='value'>` + rechargeChannel + `</div><br style='clear:both;'></div>
                            <div><div class='name'>付款方式:</div><div class='value'>` + rechargeType + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值前余额(元):</div><div class='value'>` + preBalance + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值后余额(元):</div><div class='value'>` + balance + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值状态:</div><div class='value'>` + status + `</div><br style='clear:both;'></div>
                            <div><div class='name'>操作人:</div><div class='value'>` + operateName + `</div><br style='clear:both;'></div>
                            <div class='content-bottom'><div class='content-bottom-font'>请您妥善保管</div></div>
                         </div>`

        //打印账单
        let newWindow = window.open("about:blank", "打印凭条")
        newWindow.document.write(content)
        newWindow.print();
        newWindow.close();
      },
      rowStyle() {
        return 'height:5px'
      },
      cellStyle() {
        return 'padding:0'
      },
      myCheck(...values) { /* true为空 */
        if (typeof values === undefined || values === null || values === '') return true
        let ret = true
        for (let i = 0; i < values.length; i++) {
          ret = typeof values[i] === undefined || values[i] === null || values[i] === ''
          if (ret === false) break
        }
        return ret
      },
      selectRechargeBasicInfo() { // 查询所有充值渠道、付款方式
        // 查询付款方式
        selectRechargeType().then(response => {
          const result = response.infoJson
          for (const i in result) {
            this.typeFilter.push({'text': result[i].rechargeType, 'value': result[i].id})
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '付款方式查询失败'
          })
        })
        // 查询充值渠道
        selectRechargeChannel().then(response => {
          const result = response.infoJson
          for (const i in result) {
            this.channelFilter.push({'text': result[i].rechargeChannel, 'value': result[i].id})
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '充值渠道查询失败'
          })
        })
      },
      timeFormat(cellValue) {
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return format(cellValue, 'YYYY-MM-DD HH:mm:ss')
        }
        return '--'
      },
      tableTimeFormat(row, column, cellValue) { // 表格中时间格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return format(cellValue, 'YYYY-MM-DD HH:mm:ss')
        }
        return '--'
      },
      tableStringFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return cellValue
        }
        return '--'
      }, tableHiddenStringFormat(cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return cellValue
        }
        return '--'
      }, statusFormat(row, column, cellValue) {
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          if (cellValue === 0) return '支付中'
          else if (cellValue === 1 || cellValue === 5) return '充值中'
          else if (cellValue === 2) return '充值成功'
          else if (cellValue === 3) return '支付失败'
          else if (cellValue === 4) return <font style="color: red">充值失败</font>
        }
      },
      tableNumberFormat(row, column, cellValue) { // 表格中数字格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return cellValue.toFixed(2)
        }
        return '--'
      }, handleSizeChange(val) { // 每页显示条数改变
        this.pageSize = val
        this.currentPage = 1
        this.tableByPage()

      },
      handleCurrentChange(val) { // 当前页数改变
        this.currentPage = val
        this.tableByPage()
      },
      searchByPage(data) {
        /* 数据总个数dataTotal, pageTotal总页数, 每页个数pagesize, 当前页数currentPage*/
        const dataTotal = data.length
        this.pageTotal = dataTotal
        /* dataTotal / pageSize + ((dataTotal % pageSize) > 0 ? 1 : 0);*/
        const start = ((this.currentPage - 1) * this.pageSize)
        const end = this.currentPage * this.pageSize
        return data.slice(start, end)
      }, tableByPage() { // 数据表格分页查询，充值统计查询
        let startTime = null
        let endTime = null
        if (this.dateInterval !== null && this.dateInterval.length != 0) {  //时间框不为空使用时间框中的时间
          startTime = format(this.dateInterval[0], "YYYY-MM-DD HH:mm:ss")
          endTime = format(this.dateInterval[1], "YYYY-MM-DD HH:mm:ss")
        } else if (this.timePeriod !== null) {  //时间区间不为空则使用时间区间的时间
          let timeJson = getStartAndEnd("now", this.timePeriod)
          startTime = format(timeJson.start, "YYYY-MM-DD HH:mm:ss")
          endTime = format(timeJson.end, "YYYY-MM-DD HH:mm:ss")
        } else {  //都为空则为异常
          this.$message({
            type: 'error',
            message: '请选择查询时间'
          })
          return
        }
        let offset = (this.currentPage - 1) * this.pageSize
        //查询数据表格
        this.tableLoading = true
        rechargeRecordByPage(this.meterIds, startTime, endTime, this.pageSize, offset, this.channelFilterTemp, this.typeFilterTemp, this.rechargeStateTemp).then(response => {
          this.tableData = response.infoJson.rows
          if (response.infoJson.total === undefined) {
            this.pageTotal = 0
          } else {
            this.pageTotal = response.infoJson.total
          }
          this.tableLoading = false
        }).catch(error => {
          this.tableLoading = false
          this.$message({
            type: 'error',
            message: '数据表格查询失败'
          })
        })
      }, handleFilterChange(filters) { // 表格筛选
        // 充值渠道筛选
        if (filters.channel !== undefined) {
          this.channelFilterTemp = filters.channel
        }
        // 付款方式筛选
        if (filters.type !== undefined) {
          this.typeFilterTemp = filters.type
        }
        //充值状态筛选
        if (filters.rechargeState !== undefined) {
          this.rechargeStateTemp = Object.assign([],filters.rechargeState)
          if (filters.rechargeState.indexOf(1) != -1 && filters.rechargeState.indexOf(5) == -1) this.rechargeStateTemp.push(5)


        }
        // 查询表格数据
        this.currentPage = 1
        this.tableByPage()
      },
      excel() { // 点击数据导出
        const fileName = '充值明细'
        const sheetName = '充值明细'
        // 查询待导出数据
        let startTime = null
        let endTime = null
        if (this.dateInterval !== null && this.dateInterval.length != 0) {  //时间框不为空使用时间框中的时间
          startTime = format(this.dateInterval[0], "YYYY-MM-DD HH:mm:ss")
          endTime = format(this.dateInterval[1], "YYYY-MM-DD HH:mm:ss")
        } else if (this.timePeriod !== null) {  //时间区间不为空则使用时间区间的时间
          let timeJson = getStartAndEnd("now", this.timePeriod)
          startTime = format(timeJson.start, "YYYY-MM-DD HH:mm:ss")
          endTime = format(timeJson.end, "YYYY-MM-DD HH:mm:ss")
        } else {  //都为空则为异常
          this.$message({
            type: 'error',
            message: '请选择查询时间'
          })
          return
        }
        // 查询数据表格
        this.fullscreenLoading = true
        rechargeRecordByPage(this.meterIds, startTime, endTime, 1000000, 0, this.channelFilterTemp, this.typeFilterTemp, this.rechargeStateTemp).then(response => {
          const dataTemp = response.infoJson.rows
          const data = []
          // 整理excel数据
          for (const i in dataTemp) {
            const map = {}
            if (!this.myCheck(dataTemp[i].recharge_time)) {
              map['充值时间'] = format(dataTemp[i].recharge_time, 'YYYY-MM-DD HH:mm:ss')
            } else {
              map['充值时间'] = '--'
            }
            if (dataTemp[i].customer_user_code !== null && dataTemp[i].customer_user_code !== undefined && dataTemp[i].customer_user_code !== '') {
              map['用户编号'] = dataTemp[i].customer_user_code
            } else {
              map['用户编号'] = '--'
            }
            if (!this.myCheck(dataTemp[i].customer_user_name)) {
              map['用户名称'] = dataTemp[i].customer_user_name
            } else {
              map['用户名称'] = '--'
            }
            if (!this.myCheck(dataTemp[i].address)) {
              map['用户地址'] = dataTemp[i].address
            } else {
              map['用户地址'] = '--'
            }
            if (dataTemp[i].meter_name !== null && dataTemp[i].meter_name !== undefined && dataTemp[i].meter_name !== '') {
              map['仪表名称'] = dataTemp[i].meter_name
            } else {
              map['仪表名称'] = '--'
            }
            if (!this.myCheck(dataTemp[i].meter_code)) {
              map['仪表编号'] = dataTemp[i].meter_code
            } else {
              map['仪表编号'] = '--'
            }
            if (dataTemp[i].channel_name !== null && dataTemp[i].channel_name !== undefined && dataTemp[i].channel_name !== '') {
              map['充值渠道'] = dataTemp[i].channel_name
            } else {
              map['充值渠道'] = '--'
            }
            if (dataTemp[i].type_name !== null && dataTemp[i].type_name !== undefined && dataTemp[i].type_name !== '') {
              map['付款方式'] = dataTemp[i].type_name
            } else {
              map['付款方式'] = '--'
            }
            if (dataTemp[i].pre_balance !== null && dataTemp[i].pre_balance !== undefined && dataTemp[i].pre_balance !== '') {
              map['表内余额（元）'] = dataTemp[i].pre_balance.toFixed(2)
            } else {
              map['表内余额（元）'] = '--'
            }
            if (dataTemp[i].recharge_amount !== null && dataTemp[i].recharge_amount !== undefined && dataTemp[i].recharge_amount !== '') {
              map['充值金额（元）'] = dataTemp[i].recharge_amount.toFixed(2)
            } else {
              map['充值金额（元）'] = '--'
            }
            if (dataTemp[i].pay_amount !== null && dataTemp[i].pay_amount !== undefined && dataTemp[i].pay_amount !== '') {
              map['应付金额（元）'] = dataTemp[i].pay_amount.toFixed(2)
            } else {
              map['应付金额（元）'] = '--'
            }
            if (dataTemp[i].balance !== null && dataTemp[i].balance !== undefined && dataTemp[i].balance !== '') {
              map['充值后表内余额（元）'] = dataTemp[i].balance.toFixed(2)
            } else {
              map['充值后表内余额（元）'] = '--'
            }
            if (dataTemp[i].real_amount !== null && dataTemp[i].real_amount !== undefined && dataTemp[i].real_amount !== '') {
              if (dataTemp[i].status === 0) map['充值状态'] = '支付中'
              else if (dataTemp[i].status === 1 || dataTemp[i].status === 5) map['充值状态'] = '充值中'
              else if (dataTemp[i].status === 2) map['充值状态'] = '充值成功'
              else if (dataTemp[i].status === 3) map['充值状态'] = '支付失败'
              else if (dataTemp[i].status === 4) map['充值状态'] = '充值失败'
            } else {
              map['充值状态'] = '--'
            }
            if (dataTemp[i].operate_name !== null && dataTemp[i].operate_name !== undefined && dataTemp[i].operate_name !== '') {
              map['操作人'] = dataTemp[i].operate_name
            } else {
              map['操作人'] = '--'
            }
            data.push(map)
          }
          // 导出表格
          const result = exportExcel(data, fileName, sheetName)
          if (result == 0) {
            this.$message({
              type: 'error',
              message: '无待导出数据'
            })
          } else if (result == 1) {
            this.$message({
              type: 'error',
              message: '导出失败'
            })
          }
          this.fullscreenLoading = false
        }).catch(error => {
          this.fullscreenLoading = false
          this.$message({
            type: 'error',
            message: '获取导出数据失败'
          })
          console.log(error)
        })
      }, getMeterIds(val) { // 获取所有子节点的仪表id
        if (val.type == 2) {
          this.meterIdsTemp.push(val.typeId)
        }
        if (val.children !== undefined && val.children !== null) {
          for (const i in val.children) {
            this.getMeterIds(val.children[i])
          }
        }
      }, timePeriodChange(val) { // 根据时间段改变设置时间框的值
        const timeJson = getStartAndEnd('now', val)
        const timeArr = [timeJson.start, timeJson.end]
        this.dateInterval = timeArr
      },
      click(data, node) { /* 树点击事件 */
        // 获取点击节点下的所有仪表id
        this.meterIds = []
        this.meterIdsTemp = []
        this.tableData = []
        this.currentPage = 1
        if (data.type === 2) {
          this.meterIds.push(data.typeId)
        } else {
          this.getMeterIds(data)
          /* console.log('数据')
           console.log(this.meterIdsTemp)*/
          this.meterIds = this.meterIdsTemp
        }
      },
      changeTime(time) {
        this.condition.startDate = time[0]
        this.condition.endDate = time[1]
      },
      /* 表格间距 */
      cellPadding() {
        return 'padding:0'
      },
      userName(val) {
        this.energyUnitForm.name = this.user.find((item) => {
          return item.id === val
        }).name
      },
      handleSelectionChange(val) { /* 树变化 */
        this.multipleSelection = val
      },
      filterNode(value, data) { /* data.id + ''转字符串,number类型报错*/
        /*if (!value) return true
        const id = (data.code + '').indexOf(value)
        const label = data.label.indexOf(value)
        return (id !== -1 || label !== -1)*/
        return filterNode(value, data)
      },
      selectEnergyUnit() {
        this.tableData = []
        this.tree = []
        this.disabled = true
        this.loading = true
        const customerId = this.$store.getters.customerId
        this.condition.customerId = customerId
        tree(customerId, null, null, this.meterType, 1).then(response => {
          if (response !== null || response !== undefined) {
            /* this.tree = response[0].children
            this.expandedKeys = []
            console.log(expandedCustomerWithMeter(this.tree))
            const keys = expandedCustomerWithMeter(this.tree, true)
            this.expandedKeys.push(keys[0].customerId)
            this.condition.energyUnitIds = keys[1].meterId*/
            this.tree = response[0].children
            this.expandedKeys = []
            const keys = expandedCustomerWithMeter(this.tree, true)
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(keys[0].customerId); // tree元素的ref value 绑定的node-key
            });
            if (keys) {
              this.expandedKeys.push(keys[0].customerId)
              this.condition.energyUnitIds = keys[1].meterId
              // 获取所有仪表id
              this.meterIds = []
              this.meterIdsTemp = []
              for (const i in this.tree) {
                this.getMeterIds(this.tree[i])
              }
              this.meterIds = this.meterIdsTemp
            }


          }
          /*console.log(this.meterIds)*/
          this.disabled = false
          this.loading = false


        }).catch(error => {
          this.tree = []
          this.$message({
            type: 'error',
            message: '能耗单元树查询失败'
          })
          this.disabled = false
          this.loading = false
          console.log(error)
        })
      },
      success() { /* 成功提示*/
        this.$notify({
          title: ' 成功',
          message: '操作成功',
          type: 'success'
        })
      },
      cleanData(data) {
        for (const i in data) data[i] = ''
      },
      getNowFormatDate() {
        var date = new Date()
        var seperator1 = '-'
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        var strDate = date.getDate()
        if (month >= 1 && month <= 9) {
          month = '0' + month
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = '0' + strDate
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate
        return currentdate
      },
      changeDateUnit(val) { /* 日周月年查询*/
        this.currentPage = 1
        this.pageSize = 10
        this.pageTotal = 1
        this.date = []
        if (val === 'day') {
          this.condition.dateUnit = 'hour'
          const startAndEnd = getStartAndEnd('now', 'day')
          this.condition.startDate = startAndEnd.start
          this.condition.endDate = startAndEnd.end
        }
        if (val === 'week') {
          this.condition.dateUnit = 'day'
          const startAndEnd = getStartAndEnd('now', 'week')
          this.condition.startDate = startAndEnd.start
          this.condition.endDate = startAndEnd.end
        }
        if (val === 'month') {
          this.condition.dateUnit = 'day'
          const startAndEnd = getStartAndEnd('now', 'month')
          this.condition.startDate = startAndEnd.start
          this.condition.endDate = startAndEnd.end
        }
        if (val === 'year') {
          this.condition.dateUnit = 'month'
          const startAndEnd = getStartAndEnd('now', 'year')
          this.condition.startDate = startAndEnd.start
          this.condition.endDate = startAndEnd.end
        }
        this.energyUnitEnergyData()
      }, labelHead(h, {column, index}) {
        const l = column.label.length
        const f = 18 // 每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，
        column.minWidth = f * l // 字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度
        // 然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
        return h('div', {class: 'table-head', style: {width: '100%'}}, [column.label])
      }

    },
    data() {
      return {
        timePeriod: 'month',
        dateInterval: [],
        data: [],
        currentPage: 1,
        pageSize: 10,
        pageTotal: 1,
        elMainStyle: {
          height: '',
          width: '100%'
        },
        elContent: {
          height: '',
          width: '100%'
        },

        typeFilterTemp: [],
        channelFilterTemp: [],
        input: '',
        filterText: '',
        tree: [], /* 树*/
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        expandedKeys: [],
        timeData: [],
        enableMeter: [],
        customer: [],
        loading: false, /* 加载*/
        tableLoading: false,
        multipleSelection: '',
        dialogTableVisible: false,
        dialogFormVisible: false,
        condition: {
          dateUnit: 'day',
          startDate: '',
          endDate: '',
          customerId: '',
          energyUnitIds: [],
          energyItemIds: '1,1,1,1,1'
        },
        dateUnit: 'day',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const startAndEnd = getStartAndEnd('now', 'week')
              const start = startAndEnd.start
              const end = startAndEnd.end

              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const startAndEnd = getStartAndEnd('now', 'month')
              const start = startAndEnd.start
              const end = startAndEnd.end
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const nowYear = new Date().getFullYear()
              const nowMonth = new Date().getMonth()
              const startAndEnd = getStartAndEnd('now', 'month')
              const monthStartDate = new Date(nowYear, nowMonth - 3, 1)
              const start = new Date(formatDate(monthStartDate) + ' 00:00:00')
              const end = startAndEnd.end
              picker.$emit('pick', [start, end])
              /* console.log()
              let start = formatDate(new Date(new Date()- (3600 * 1000 * 24 * 121))) + ' 00:00:00'
              let end = formatDate(new Date()) + ' 23:59:59'
              picker.$emit('pick', [start, end])*/
            }
          }, {
            text: '最近半年',
            onClick(picker) {
              const nowYear = new Date().getFullYear()
              const nowMonth = new Date().getMonth()
              const startAndEnd = getStartAndEnd('now', 'month')
              const monthStartDate = new Date(nowYear, nowMonth - 6, 1)
              const start = new Date(formatDate(monthStartDate) + ' 00:00:00')
              const end = startAndEnd.end
              picker.$emit('pick', [start, end])
              /* const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])*/
            }
          }]
        },
        date: [],
        time: [],
        buttonLoading: false,
        user: [],
        energyUnitForm: {
          id: '',
          name: '',
          enabled: '',
          note: '',
          grade: '',
          order: '',
          approachId: '',
          aName: '',
          parentId: '',
          approachName: '',
          father: {}
        },
        energyUnit: [],

        meterIds: [],
        meterIdsTemp: [],
        disabled: false,
        customerMeter: {
          id: '',
          meterId: '',
          customerUserId: ''
        },
        meter: [],
        formLabelWidth: '120px',
        options: [
          {value: '1', label: '区域'},
          {value: '2', label: '楼宇'}
        ],
        value: '区域',
        showType: ''/* 0:添加口径 1:修改口径 2:添加能耗单元 3:添加子能耗单元*/,
        title: '',
        tabPosition: 'top',
        meterType: 2,
        tableData: [],
        excelData: [],
        channelFilter: [],
        typeFilter: [],
        rechargeStateTemp: [],
        rechargeState: [{'text': '支付中', 'value': 0}, {'text': '充值中', 'value': 1}, {
          'text': '充值成功',
          'value': 2
        }, {'text': '支付失败', 'value': 3}, {'text': '充值失败', 'value': 4}]
      }
    }
  }
</script>
<!--<style scoped>


    #main {
        width: 100%;
        height: 100%;
    }

    #left {
        float: left;
        width: 250px;
        max-height: 320px;
        height: auto;
        background-color: red;
        /*
                background-color: black;*/
    }

    #content {

        background-color: orange;
        margin-left: 250px;
        height: 300px;
    }

</style>-->
<style scoped rel="stylesheet/scss" lang="scss">


    .energy-data-query-manage-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        font-size: 1rem;
        .recharge-detail-query-head {
            height: 3rem;
            width: 100%;
            display: flex;
            flex-direction: row;
            .recharge-detail-query-head-left {
                padding-top: 1rem;

                font-size: 15px;
                font-weight: 600;

                width: 16%;
                color: black;

                /*background-color: violet;*/
            }
            .recharge-detail-query-head-right {
                font-size: 15px;
                font-weight: 600;
                padding-top: 1rem;
                width: 84%;
                /*background-color: yellow;*/
            }
        }
        .recharge-detail-query-content {
            margin-top: 0.5rem;
            height: calc(100% - 6rem);
            display: flex;
            flex-direction: row;
            width: 100%;

            .energy-data-query-left {
                height: 100%;
                width: 16%;
                background-color: white;

                .div-hr {
                    margin-top: calc(0.8rem - 1px);
                    width: 100%;
                    height: 1px;
                    background-color: #d1dbde;
                }
                .left-item {
                    align-items: center;
                    padding-top: 0.5rem;
                    .el-form-item {
                    }
                }
                .tree {

                    margin-top: 0.5rem;
                    padding-bottom: 0.5rem;
                    background-color: white;

                }
                .el-tree {
                    min-width: 100%;
                    display: inline-block !important;
                }
            }
            .energy-data-query-right {
                background-color: #ffffff;
                margin-left: 2rem;
                width: calc(84% - 2rem);
                height: 100%;
                .content {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    height: calc(100vh - 12.75rem);
                    .energy-config-pagination {
                        display: flex;
                        width: 100%;
                        padding-top: 0.5rem;
                        padding-bottom: 0.5rem;
                        height: 2rem;
                        align-items: center;
                        flex-direction: row;
                        background-color: white;
                    }
                }

            }
        }

        .demo-table-expand .el-form-item {
            margin-right: 30px;
            margin-bottom: 0;
        }

        .demo-table-expand > .el-form-item > .el-form-item__label {
            font-size: 12px;
            font-weight: bold;
            color: #909399;
        }
        .demo-table-expand > .el-form-item > .el-form-item__content {
            font-size: 12px;
        }

    }

    /*#tree.el-tree-node {
        min-width: 100%;
    }*/
    /* .el-main {
         padding: 0;
     }
 */
    /* .div-hr {
         height: 1px;
         background-color: #dedede;
         margin-top: 7%;
     }*/

    /* .log-condition-box {
         font-size: 14px;
         height: 60px;
         display: flex;
         align-items: center;

     }

     #myChart {
         width: 100%;
         height: 100%;
     }

     .log-search-button {
         margin-top: 10px;
     }

     .el-table th > .cell {
         white-space: nowrap;
     }*/

</style>
